import React from 'react';
import { Dumbbell, Flame, Trophy, Scale, Star, Lock } from 'lucide-react';

export const BADGE_META = {
  first_workout: {
    icon: Dumbbell, color: 'from-sky-500 to-blue-600',
    labelFr: '1ère séance', labelEn: 'First workout',
    descFr: 'Terminer votre 1er entraînement', descEn: 'Complete your 1st workout',
  },
  streak_7: {
    icon: Flame, color: 'from-orange-500 to-red-600',
    labelFr: '7 jours de suite', labelEn: '7-day streak',
    descFr: '7 jours consécutifs de suivi', descEn: '7 consecutive days logged',
  },
  program_completed: {
    icon: Trophy, color: 'from-amber-400 to-yellow-600',
    labelFr: '1er programme fini', labelEn: 'First program done',
    descFr: 'Terminer un programme complet', descEn: 'Complete a full program',
  },
  weight_loss_5kg: {
    icon: Scale, color: 'from-emerald-500 to-teal-600',
    labelFr: '5 kg perdus', labelEn: '5 kg lost',
    descFr: 'Perdre 5 kg depuis votre 1ère pesée', descEn: 'Lose 5 kg since your first weigh-in',
  },
  community_star: {
    icon: Star, color: 'from-yellow-400 to-pink-500',
    labelFr: 'Étoile de la communauté', labelEn: 'Community star',
    descFr: 'Avoir une recette "coup de cœur du coach"', descEn: 'Get a "coach\'s pick" recipe',
  },
};

/** Bandeau de badges (débloqués en couleur, verrouillés en gris) — motivation par la
 * progression visible, jamais bloquant. */
export const BadgesStrip = ({ en, badges = [] }) => (
  <div className="flex items-center gap-3 overflow-x-auto pb-1 mb-6 -mx-1 px-1" data-testid="badges-strip">
    {Object.entries(BADGE_META).map(([key, meta]) => {
      const unlocked = badges.includes(key);
      const Icon = meta.icon;
      return (
        <div
          key={key}
          title={en ? meta.descEn : meta.descFr}
          className={`shrink-0 w-[92px] flex flex-col items-center gap-1.5 rounded-xl px-2 py-3 border transition-colors ${
            unlocked ? 'border-white/10 bg-white/[0.03]' : 'border-white/5 bg-black/20 opacity-50'
          }`}
          data-testid={`badge-${key}${unlocked ? '-unlocked' : '-locked'}`}
        >
          <div className={`w-9 h-9 rounded-full flex items-center justify-center ${unlocked ? `bg-gradient-to-br ${meta.color}` : 'bg-zinc-800'}`}>
            {unlocked ? <Icon className="w-4.5 h-4.5 text-white" /> : <Lock className="w-3.5 h-3.5 text-zinc-500" />}
          </div>
          <span className={`text-[10px] font-bold text-center leading-tight ${unlocked ? 'text-white' : 'text-zinc-500'}`}>
            {en ? meta.labelEn : meta.labelFr}
          </span>
        </div>
      );
    })}
  </div>
);

export default BadgesStrip;
